// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import TransparentCross from '../_raw/ui/icon_transparent_cross.svg';
import withIconProps from '../withIconProps';

export default withIconProps(TransparentCross);
